import clsx from 'clsx'
import React from 'react'

interface Props {
  className?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
}

export const Logo = (props: Props) => {
  const { loading: loadingFromProps, priority: priorityFromProps, className } = props

  const loading = loadingFromProps || 'lazy'
  const priority = priorityFromProps || 'low'

  return (
    /* eslint-disable @next/next/no-img-element */
    <div className="flex h-full w-full max-w-full items-center justify-center gap-4 overflow-hidden sm:gap-4 md:gap-8">
      <img
        alt="AAC Logo"
        width={148}
        height={72}
        loading={loading}
        fetchPriority={priority}
        decoding="async"
        className={clsx(
          'max-w-[80px] sm:max-w-[148px] w-auto h-auto sm:h-[72px] flex-shrink-0',
          className,
        )}
        src="/aac.svg"
      />
      <span className="h-full w-0.5 flex-shrink-0 bg-black sm:w-0.5"></span>
      <img
        alt="Interreg Logo"
        width={256}
        height={32}
        loading={loading}
        fetchPriority={priority}
        decoding="async"
        className={clsx(
          'max-w-[120px] sm:max-w-[256px] w-auto h-auto sm:h-[32px] flex-shrink-0',
          className,
        )}
        src="/logo.png"
      />
    </div>
  )
}
